import { createFileRoute } from "@tanstack/react-router";
import { ServicePage } from "@/components/ServicePage";
import { AUTOMACAO_PAGES } from "@/lib/automacao-pages";

const data = AUTOMACAO_PAGES["consultoria-de-automacao-comercial"];

export const Route = createFileRoute("/consultoria-de-automacao-comercial")({
  head: () => ({
    meta: [
      { title: data.seoTitle },
      { name: "description", content: data.seoDescription },
      { property: "og:title", content: data.seoTitle },
      { property: "og:description", content: data.seoDescription },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://www.svgmultimidia.com.br/consultoria-de-automacao-comercial" },
    ],
    links: [{ rel: "canonical", href: "https://www.svgmultimidia.com.br/consultoria-de-automacao-comercial" }],
  }),
  component: () => <ServicePage {...data.page} />,
});
